import React from "react";

const Family = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#E9ECF0" />
      <path d="M29 20L20 12L11 20V30H29V20Z" fill="white" />
      <path
        d="M18.6498 10.2197L9.79972 18.2197C9.70196 18.3086 9.62279 18.416 9.56681 18.5357C9.51082 18.6555 9.47913 18.7851 9.47355 18.9171C9.46797 19.0492 9.48865 19.181 9.53434 19.305C9.58002 19.4291 9.64981 19.5428 9.73972 19.6397L9.88975 19.7997C10.0691 19.9941 10.3181 20.1096 10.5824 20.1208C10.8466 20.1321 11.1045 20.0382 11.2997 19.8597L19.2997 12.5597C19.4835 12.3938 19.7222 12.302 19.9698 12.302C20.2173 12.302 20.456 12.3938 20.6397 12.5597L28.6397 19.8597C28.8349 20.0382 29.0929 20.1321 29.3572 20.1208C29.6214 20.1096 29.8704 19.9941 30.0497 19.7997L30.1997 19.6397C30.289 19.5421 30.3581 19.4279 30.403 19.3035C30.4478 19.1791 30.4675 19.0471 30.461 18.915C30.4545 18.783 30.4219 18.6535 30.365 18.5342C30.3082 18.4148 30.2282 18.3079 30.1297 18.2197L21.2798 10.2197C20.9154 9.90173 20.4483 9.72656 19.9648 9.72656C19.4812 9.72656 19.0141 9.90173 18.6498 10.2197Z"
        fill="#F57C75"
      />
      <path d="M19 21H14V30H19V21Z" fill="#737A83" />
      <path d="M26 21H22V25H26V21Z" fill="#737A83" />
    </svg>
  );
};

export default Family;
